import Vue from 'vue';
import Router from 'vue-router';
import sign from '@/components/app-sign';
import list from '@/components/app-list';
import project from '@/components/app-project';
import test from '@/components/_test';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'sign',
        component: sign,
    }, {
        path: '/list',
        name: 'list',
        component: list,
        meta: {
            requiresAuth: true,
        },
    }, {
        path: '/project/:id',
        name: 'project',
        component: project,
        meta: {
            requiresAuth: true,
        },
    }, {
        path: '/test',
        name: 'test',
        component: test,
    }],
});



// WEBPACK FOOTER //
// ./src/router/index.js